import { render, staticRenderFns } from "./detail_investments.vue?vue&type=template&id=7ce34c9e&scoped=true&"
import script from "./detail_investments.vue?vue&type=script&lang=js&"
export * from "./detail_investments.vue?vue&type=script&lang=js&"
import style0 from "./detail_investments.vue?vue&type=style&index=0&id=7ce34c9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce34c9e",
  null
  
)

export default component.exports